module.exports = __webpack_public_path__ + "img/w28.299298d0.svg";